export const POINTS_CONSUME_NAME = 'Yeah积分'

export const POINTS_CONSUME_DESC =
  '运行Agent或flow需要消耗Yeah积分，每次运行消耗的Yeah积分根据实际使用的模型计算，不同模型消耗的Yeah积分不一致'

export const POINTS_CONSUME_MODEL_DESC = '每月可用来运行Agent和flow的积分数量'
